export const MAX_UPLOAD_FILES_COUNT = 11
export const MAX_AVATAR_SIZE_IN_BYTES = 30000000
